export const TIME = {
  secondMs: 1_000,
  minuteSeconds: 60,
  hourSeconds: 3_600,
  daySeconds: 86_400,
  weekSeconds: 604_800,
  monthSeconds: 2_592_000,
  stakeCooldownSeconds: 86_400,
  transactionDeadlineSeconds: 1_200,
  allowancePollIntervalMs: 1_000,
  dataRefreshDelayMs: 1_500,
  dataRetryDelayMs: 2_500,
  walletProviderRetryDelayMs: 750,
  transactionRefreshDelayMs: 2_000,
  priceRefreshIntervalMs: 60_000,
  dashboardDataPollIntervalMs: 300_000,
  generatedRewardPollIntervalMs: 30_000,
  supportUnreadPollIntervalMs: 30_000,
  miningQuoteRetryDelayMs: 750,
  miningQuoteRetryAttempts: 3,
  clockTickIntervalMs: 1_000,
  transactionReceiptPollAttempts: 8,
  transactionReceiptPollDelayMs: 750,
  rpcFailureCooldownMs: 30_000,
} as const;

// Test environments can shorten this date and the durations above. Pool IDs
// and contract cooldowns must use the same values in the deployed contract.
import { APP_SETTINGS } from '@/lib/config/app-settings';
export const COMING_SOON_LAUNCH_AT_ISO = APP_SETTINGS.comingSoonLaunchAtIso;

export const PERIOD = {
  day: BigInt(TIME.daySeconds),
  week: BigInt(TIME.weekSeconds),
  month: BigInt(TIME.monthSeconds),
} as const;
